import {
  EDITOR_UPLOD_SEARCHED_IMAGE_BEGIN,
  EDITOR_UPLOD_SEARCHED_IMAGE_SUCCESS,
  EDITOR_UPLOD_SEARCHED_IMAGE_FAILURE,
  EDITOR_UPLOD_SEARCHED_IMAGE_DISMISS_ERROR,
} from './constants';
import { toast } from 'react-toastify';
import axios from 'axios';
export function uplodSearchedImage(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_UPLOD_SEARCHED_IMAGE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/assets/${projectId}/search-upload`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_UPLOD_SEARCHED_IMAGE_SUCCESS,
            data: res.data,
          });
          toast.success('File added to your Assets!', {});
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: EDITOR_UPLOD_SEARCHED_IMAGE_FAILURE,
            data: { error: err },
          });
          toast.error('Failed to upload !', {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUplodSearchedImageError() {
  return {
    type: EDITOR_UPLOD_SEARCHED_IMAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_UPLOD_SEARCHED_IMAGE_BEGIN:
      return {
        ...state,
        uplodSearchedImagePending: true,
        uplodSearchedImageError: null,
        showImageSearchUploadError: true,
        toggleAsset: false,
        showImageUploadLoader: true,
      };

    case EDITOR_UPLOD_SEARCHED_IMAGE_SUCCESS:
      return {
        ...state,
        uplodSearchedImagePending: false,
        uplodSearchedImageError: null,
        showImageSearchUploadError: false,
        assets: action.data,
        toggleAsset: false,
        showImageUploadLoader: false,
      };

    case EDITOR_UPLOD_SEARCHED_IMAGE_FAILURE:
      return {
        ...state,
        uplodSearchedImagePending: false,
        uplodSearchedImageError: action.data.error,
        showImageSearchUploadError: false,
        toggleAsset: false,
        showImageUploadLoader: false,
      };

    case EDITOR_UPLOD_SEARCHED_IMAGE_DISMISS_ERROR:
      return {
        ...state,
        uplodSearchedImageError: null,
        showImageSearchUploadError: false,
        toggleAsset: false,
      };

    default:
      return state;
  }
}
